module.exports = __webpack_public_path__ + "static/media/galeryCoatings4.eaeb1dbd.jpg";